import React, { useEffect } from "react";
import "./App.css";
import MemberPortal from "./MemberPortal";
import { ConfigProvider } from "antd";
import ReactGA from "react-ga";
import { disableConsole, restoreConsole } from "./consoleManager";
import IdleMonitor from "./IdleMonitor";
import whitelabelConfig from "@whitelabel-config";
ReactGA.initialize("UA-160648315-3");

function App() {
  useEffect(() => {
    if (process.env.REACT_APP_PRODUCTION === 'true') {
      disableConsole();
    } else {
      restoreConsole();
    }
    return () => {
      restoreConsole();
    };
  }, []);

  return (
    <>
      <ConfigProvider
        theme={{
          token: {
            fontFamily: "Montserrat,sans-serif",
          },
        }}
      >
        {whitelabelConfig.uiSettings.isIdleTimeout && (
          <IdleMonitor />
        )}
        <MemberPortal />
      </ConfigProvider>
    </>
  );
}

export default App;
